import { createSelector } from '@reduxjs/toolkit';
import { selectConfigFromBootstrap, selectFeatureBehaviorFromBootstrap } from 'store/slice/bootstrap';
import { BootstrapConfig } from 'core/type/BootstrapConfig.types';
import { selectPageTypeId } from 'store/slice/navigation';
import { OperationKey } from 'store/api/api.types';
import { ActivityCardProps } from 'core/type/ActivityCard.types';
import { isOn } from 'core/window/bootstrapConfig';
import { FeatureName } from 'core/constant/FeatureName';
import { ValueFilterType } from 'gql/autogen/ValueFilterType';
import { Sort } from 'gql/autogen/Sort';

interface OwnProps {
    operationKey: OperationKey;
    title: string;
    cityId?: number;
    cityName?: string;
    isPopularActivities?: boolean;
    dataElementName: string;
    dataElementValue?: string;
    numberOfActivities: number;
    onHorizontalScroll?: () => void;
    onScroll?: () => void;
    filterActivityId?: string;
    filterType?: ValueFilterType;
    filterCategory?: string;
    setPopularActivitiesResponse?: (popularActivitiesList: ActivityCardProps[]) => void;
    defaultSort: Sort;
}

interface StateProps {
    config: BootstrapConfig;
    pageTypeId: number;
    isSearchBoxFeatureGroup: boolean;
    isPageContainerSpacing: boolean;
}

export type RecommendedActivitiesCarouselProps = OwnProps & StateProps;

export const mapStateToProps = createSelector(
    selectConfigFromBootstrap,
    selectPageTypeId,
    selectFeatureBehaviorFromBootstrap,
    (config, pageTypeId, featureBehaviours): StateProps => {
        const isPageContainerSpacing = isOn(FeatureName.PageContainerSpacing, config);
        return {
            config,
            pageTypeId,
            isPageContainerSpacing,
            isSearchBoxFeatureGroup: featureBehaviours.SearchBoxFeatureGroup,
        };
    },
);
